var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});
dependencies["macros/urls.j2"] = require( "macros/urls.j2" );
dependencies["macros/price-promo-labels.j2"] = require( "macros/price-promo-labels.j2" );




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["core/templates/macros/product-price.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
env.getTemplate("macros/urls.j2", false, "core/templates/macros/product-price.j2", false, function(t_2,t_1) {
if(t_2) { cb(t_2); return; }
t_1.getExported(context.getVariables(), frame, function(t_3,t_1) {
if(t_3) { cb(t_3); return; }
if(t_1.hasOwnProperty("imageUrl")) {
var t_4 = t_1.imageUrl;
} else {
cb(new Error("cannot import 'imageUrl'")); return;
}
context.setVariable("imageUrl", t_4);
output += "\n";
env.getTemplate("macros/price-promo-labels.j2", false, "core/templates/macros/product-price.j2", false, function(t_6,t_5) {
if(t_6) { cb(t_6); return; }
t_5.getExported(function(t_7,t_5) {
if(t_7) { cb(t_7); return; }
if(t_5.hasOwnProperty("displayPromoLabels")) {
var t_8 = t_5.displayPromoLabels;
} else {
cb(new Error("cannot import 'displayPromoLabels'")); return;
}
context.setVariable("displayPromoLabels", t_8);
var macro_t_9 = runtime.makeMacro(
["price", "core"], 
["currencyFormattingOverrides"], 
function (l_price, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("price", l_price);
frame.set("core", l_core);
frame.set("currencyFormattingOverrides", kwargs.hasOwnProperty("currencyFormattingOverrides") ? kwargs["currencyFormattingOverrides"] : runtime.contextOrFrameLookup(context, frame, "None"));
var t_10 = "";t_10 += runtime.suppressValue(env.getFilter("currency").call(context, l_price,l_core,runtime.contextOrFrameLookup(context, frame, "currencyFormattingOverrides")), env.opts.autoescape);
;
frame = frame.pop();
return new runtime.SafeString(t_10);
});
context.addExport("displayPriceValue");
context.setVariable("displayPriceValue", macro_t_9);
var macro_t_11 = runtime.makeMacro(
["productInfo", "core"], 
["showRange"], 
function (l_productInfo, l_core, kwargs) {
frame = frame.push(true);
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("productInfo", l_productInfo);
frame.set("core", l_core);
frame.set("showRange", kwargs.hasOwnProperty("showRange") ? kwargs["showRange"] : true);
var t_12 = "";t_12 += "\n    ";
var t_13;
t_13 = runtime.memberLookup((l_productInfo),"skuInfo");
frame.set("skuInfo", t_13, true);
if(frame.topLevel) {
context.setVariable("skuInfo", t_13);
}
if(frame.topLevel) {
context.addExport("skuInfo", t_13);
}
t_12 += "\n    ";
var t_14;
t_14 = (runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"hasMarkdown") && runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"markdownState") == "PERMANENT"?true:false);
frame.set("isPermanentMarkdown", t_14, true);
if(frame.topLevel) {
context.setVariable("isPermanentMarkdown", t_14);
}
if(frame.topLevel) {
context.addExport("isPermanentMarkdown", t_14);
}
t_12 += "\n    ";
var t_15;
t_15 = (runtime.contextOrFrameLookup(context, frame, "isPermanentMarkdown") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceLow") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceHigh")?" c-product-meta__current-price--sale":"");
frame.set("salePriceClass", t_15, true);
if(frame.topLevel) {
context.setVariable("salePriceClass", t_15);
}
if(frame.topLevel) {
context.addExport("salePriceClass", t_15);
}
t_12 += "\n\n    ";
t_12 += "\n    ";
if(l_productInfo && runtime.memberLookup((l_productInfo),"selectedSku") && runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku") && runtime.contextOrFrameLookup(context, frame, "showRange")) {
t_12 += "\n\n        ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")),"salePrice") != runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")),"listPrice")) {
t_12 += "\n            <span class=\"c-product-meta__current-price";
t_12 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "salePriceClass"), env.opts.autoescape);
t_12 += "\" data-qa-current-price>";
t_12 += runtime.suppressValue((lineno = 41, colno = 112, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")),"salePrice"),l_core])), env.opts.autoescape);
t_12 += "</span>\n        ";
;
}
else {
t_12 += "\n            <span class=\"c-product-meta__current-price\" data-qa-current-price>";
t_12 += runtime.suppressValue((lineno = 43, colno = 96, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")),"salePrice"),l_core])), env.opts.autoescape);
t_12 += "</span>\n        ";
;
}
t_12 += "\n\n    ";
;
}
else {
t_12 += "\n        ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceLow") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceHigh") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceHigh")) {
t_12 += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceLow") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceHigh") && runtime.contextOrFrameLookup(context, frame, "showRange")) {
t_12 += "\n                <span class=\"c-product-meta__current-price";
t_12 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "salePriceClass"), env.opts.autoescape);
t_12 += "\" data-qa-current-pricerange>";
t_12 += runtime.suppressValue((lineno = 49, colno = 121, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceLow"),l_core])), env.opts.autoescape);
t_12 += "&ndash;";
t_12 += runtime.suppressValue((lineno = 49, colno = 175, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceHigh"),l_core])), env.opts.autoescape);
t_12 += "</span>\n            ";
t_12 += "\n            ";
;
}
else {
t_12 += "\n                <span class=\"c-product-meta__current-price";
t_12 += runtime.suppressValue(runtime.contextOrFrameLookup(context, frame, "salePriceClass"), env.opts.autoescape);
t_12 += "\" data-qa-current-price>";
t_12 += runtime.suppressValue((lineno = 52, colno = 116, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceLow"),l_core])), env.opts.autoescape);
t_12 += "</span>\n            ";
;
}
t_12 += "\n        ";
;
}
t_12 += "\n    ";
;
}
t_12 += "\n\n    ";
t_12 += "\n        ";
if(l_productInfo && runtime.memberLookup((l_productInfo),"selectedSku") && runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")) {
t_12 += "\n            ";
if(runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")),"salePrice") != runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")),"listPrice")) {
t_12 += "\n                <span class=\"c-product-meta__original-price\" data-qa-orig-price> ";
t_12 += runtime.suppressValue((lineno = 62, colno = 99, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.memberLookup((runtime.memberLookup((l_productInfo),"selectedSku")),"sku")),"listPrice"),l_core])), env.opts.autoescape);
t_12 += "</span>\n            ";
;
}
t_12 += "\n        ";
;
}
else {
t_12 += "\n            ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceLow") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow") || runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"salePriceHigh") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceHigh")) {
t_12 += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceHigh") && runtime.contextOrFrameLookup(context, frame, "showRange")) {
t_12 += "\n                    ";
t_12 += "\n                    <span class=\"c-product-meta__original-price\" data-qa-orig-pricerange>\n                        ";
t_12 += runtime.suppressValue((lineno = 70, colno = 42, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow"),l_core])), env.opts.autoescape);
t_12 += "&ndash;";
t_12 += runtime.suppressValue((lineno = 70, colno = 96, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceHigh"),l_core])), env.opts.autoescape);
t_12 += "</span>";
t_12 += "\n\n                ";
;
}
else {
t_12 += "\n                    ";
t_12 += "\n                    <span class=\"c-product-meta__original-price\" data-qa-orig-price>\n                        ";
t_12 += runtime.suppressValue((lineno = 75, colno = 42, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow"),l_core])), env.opts.autoescape);
t_12 += "</span>";
t_12 += "\n                ";
;
}
t_12 += "\n            ";
;
}
else {
t_12 += "\n\n                ";
if(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow") != runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceHigh") && runtime.contextOrFrameLookup(context, frame, "showRange")) {
t_12 += "\n                    ";
t_12 += "\n                    <span class=\"c-product-meta__current-price\" data-qa-current-pricerange>\n                        ";
t_12 += runtime.suppressValue((lineno = 82, colno = 42, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow"),l_core])), env.opts.autoescape);
t_12 += "&ndash;";
t_12 += runtime.suppressValue((lineno = 82, colno = 96, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceHigh"),l_core])), env.opts.autoescape);
t_12 += "</span>";
t_12 += "\n                ";
;
}
else {
t_12 += "\n                    ";
t_12 += "\n                    <span class=\"c-product-meta__current-price\" data-qa-current-price>\n                        ";
t_12 += runtime.suppressValue((lineno = 86, colno = 42, runtime.callWrap(macro_t_9, "displayPriceValue", context, [runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "skuInfo")),"listPriceLow"),l_core])), env.opts.autoescape);
t_12 += "</span>";
t_12 += "\n                ";
;
}
t_12 += "\n            ";
;
}
t_12 += "\n        ";
;
}
t_12 += "\n    ";
t_12 += "\n\n    ";
if(l_productInfo && runtime.memberLookup((l_productInfo),"promotionLabels")) {
t_12 += "\n\n        ";
var t_16;
t_16 = runtime.memberLookup((l_productInfo),"promotionLabels");
frame.set("promos", t_16, true);
if(frame.topLevel) {
context.setVariable("promos", t_16);
}
if(frame.topLevel) {
context.addExport("promos", t_16);
}
t_12 += "\n\n        ";
if(env.getFilter("length").call(context, runtime.contextOrFrameLookup(context, frame, "promos")) > 0) {
t_12 += "\n\n            ";
t_12 += runtime.suppressValue((lineno = 98, colno = 31, runtime.callWrap(t_8, "displayPromoLabels", context, [l_core,runtime.contextOrFrameLookup(context, frame, "promos")])), env.opts.autoescape);
t_12 += "\n\n        ";
;
}
t_12 += "\n\n    ";
;
}
t_12 += "\n\n";
;
frame = frame.pop();
return new runtime.SafeString(t_12);
});
context.addExport("displayPricing");
context.setVariable("displayPricing", macro_t_11);
output += "\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
})})})});
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["core/templates/macros/product-price.j2"] , dependencies)